<template>
  <delete-data-request-modal
    :status-delete-data-request-modal="statusDeclinedRequestModal"
    :selected-request="selectedRequest"
    title="Solicitação reprovada"
    sub-title="Motivo disparado por e-mail:"
    @closeModal="$emit('closeDeclinedRequestModal')"
  >
    <v-card-text class="pb-1">
      <v-row>
        <v-col cols="12">
          <v-card color="grey lighten-5" flat>
            <v-card-text>
              <p class="grey--text text--darken-1" style="white-space: pre-line">{{ selectedRequest.delete_data_request.reply }}</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="justify-end align-center">
          <v-row>
            <v-layout class="col-12 justify-end align-center">
              <mf-button label="Fechar" @click="$emit('closeDeclinedRequestModal')" />
            </v-layout>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </delete-data-request-modal>
</template>

<script>
import DeleteDataRequestModal from '@/modules/clientes/gerenciamento/views/components/DeleteDataRequestModal.vue'

export default {
  name: 'DeclinedRequestModal',

  components: {
    DeleteDataRequestModal,
  },

  props: {
    statusDeclinedRequestModal: {
      type: Boolean,
      required: true,
    },

    selectedRequest: {
      type: Object,
      required: true,
    },
  },
}
</script>
